module.exports = __webpack_public_path__ + "img/XL_PARAMETRES.9cfdc370.svg";